"use client"
import useSWR from "swr"
import { api } from "@/lib/api-client"
import { defaultUploadPolicy, type UploadPolicySettings } from "@/modules/uploads/policy"
export const uploadPolicyEndpoint = "/api/upload-policy"
export function useUploadPolicy() {
  const remote = useSWR<UploadPolicySettings>(uploadPolicyEndpoint, api, { revalidateOnFocus: true, focusThrottleInterval: 1000, dedupingInterval: 1000, refreshInterval: 10000, shouldRetryOnError: false })
  return { policy: remote.data?.values ?? defaultUploadPolicy, ready: !!remote.data, error: remote.error, refresh: remote.mutate }
}
